<template>
  <div class="pad-header-container">
    <div class="pad-header-operate">
      <template v-if="IsHome">
        <!-- <User /> -->

        <!-- <div :class="{'bell':true,'unread':newsNum>0?true:false}" @click="toNewsInfo"> -->
          <!-- <i class="fa fa-bell-o" style="font-size:16px;"></i> -->
          <!-- <span class="tips">{{newsNum}}</span> -->
        <!-- </div> -->
      </template>
      <template v-else>
        <div class="pad-header-module-back" @click="back">
          <i class="fa fa-angle-left fa-lg"></i>
          <!-- <span>返回</span> -->
        </div>
      </template>
    </div>
    <div class="pad-header-title">
      <span>{{Title}}</span>
    </div>
  </div>
</template>
<script>
// import User from "../../User";
export default {
  data() {
    return {
      newsNum: this.$store.state.core.unreadMsgNum,  //未读消息数
      newsData: {},
    };
  },
  props: {
    IsHome: Boolean,
    Title: String
  },
  mounted() {
    this.loadData();
  },
  // components: { User },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toNewsInfo() {
      this.$router.push({ name: "core-newsInfo" });
    },
    loadData() {
      let _this = this;
      _this.$curl.get("/api/core/remind/index").then(res => {
        _this.newsData = res;
        _this.newsTotals();
      });
    },
    // 计算总消息条数
    newsTotals() {
      let newsTotals = 0;
      for (let key in this.newsData) {
        newsTotals += this.newsData[key].children.Sum(k => k.msgIds.length);
      }
      let newsTotal = newsTotals > 99 ? "99+" : newsTotals;
      // console.log("fffffffffffff",newsTotal)
      this.$store.commit("core/setUnreadMsgNum", newsTotal);
      this.$nextTick(() => {
        this.newsNum = this.$store.state.core.unreadMsgNum;  //从store中获取未读消息数
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.pad-header-container {
  height: 100%;
  display: flex;
  position: relative;
  .pad-header-operate {
    flex-shrink: 0;
    width: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    height: 50px;
    .pad-header-module-back {
      font-size: 1.3em;
      color: #ecdfdf;
      cursor: pointer;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #fff;
      }
      i {
        font-size: 1.63rem;
      }
      span {
        margin-left: 2px;
      }
    }
  }

  .pad-header-title {
    flex-grow: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 1.4em;
    justify-content: center;
    // margin-left: -33px;
  }
}
.bell{
  &.unread{
    position: relative;
    &::after{
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: -4px;
      width: 6px;
      height: 6px;
      background-color: #ec4d49;
      border-radius: 50%;
    }
  }
  .tips{
    display: inline-block;
    background-color: #ec4d49;
    border-radius: 50%;
    padding: 3px;
    width: 40px;
    height: 40px;
  }
}
</style>